import { render, staticRenderFns } from "./BotaoJuntarDocumentoEmLote.vue?vue&type=template&id=745c3b3a&scoped=true"
import script from "./BotaoJuntarDocumentoEmLote.vue?vue&type=script&lang=js"
export * from "./BotaoJuntarDocumentoEmLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c3b3a",
  null
  
)

export default component.exports